/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/internal-account-statements": {
    /**
     * List Internal Account Statements
     * @description Lists all available statements for platform financial accounts, with optional filtering by specific internal account ID
     */
    get: operations["listInternalAccountStatements"];
  };
  "/internal-account-statements/{internalAccountStatementId}": {
    /**
     * Retrieve Internal Account Statement
     * @description Retrieves a single account statement by its ID, including all transaction entries within the statement period
     */
    get: operations["retrieveInternalAccountStatement"];
  };
  "/internal-accounts": {
    /**
     * List Internal Accounts
     * @description Returns a list of internal accounts with optional filtering by account type.
     */
    get: operations["listInternalAccounts"];
    /**
     * Create Internal Account
     * @description Creates a new internal account for the customer.
     * - Clearing, Banking, TaxWithholding accounts only support USD currency
     * - ApPrefunding accounts support USD, CAD, and EUR currencies
     * - ApPayouts accounts support USD, CAD, and EUR currencies
     * - InternationalClearing accounts support USD and CAD currencies
     */
    post: operations["createInternalAccount"];
  };
  "/internal-accounts/{internalAccountId}": {
    /**
     * Retrieve Internal Account
     * @description Retrieves details of a specific internal account by its ID.
     */
    get: operations["getInternalAccount"];
  };
  "/internal-accounts/{internalAccountId}/balance": {
    /**
     * Retrieve Internal Account Balance
     * @description Retrieves the current monetary balance, along with the respective currency, for any supported internal account type.
     * Supported account types include Business Banking, Withholdings, Clearing, AP Prefunding, AP Payout, and International Clearing.
     */
    get: operations["getInternalAccountBalance"];
  };
  "/internal-accounts/{internalAccountId}/transfers": {
    /**
     * Create Internal Account Transfer
     * @description Initiates a new transfer (deposit or withdrawal) for an internal account.
     * The transfer is created in a pending state and will be processed according to the specified payment method and timing.
     * Supports ACH, wire transfers, and internal transfers between Wingspan accounts.
     */
    post: operations["createInternalAccountTransfer"];
  };
  "/internal-accounts/{internalAccountId}/transactions": {
    /**
     * List transactions for a specific internal account
     * @description Retrieves a list of transactions for a specific internal account, with support for filtering, sorting, and pagination.
     * Supported account types include Business Banking, Withholdings, Clearing, AP Prefunding, AP Payout, and International Clearing.
     */
    get: operations["listInternalAccountTransactions"];
  };
}

export type webhooks = Record<string, never>;

export interface components {
  schemas: {
    InternalAccount: {
      status: components["schemas"]["InternalAccountStatus"];
      customerUserId?: string;
      customerName?: string;
      name: string;
      type: components["schemas"]["InternalAccountType"];
      numbers?: components["schemas"]["InternalAccountNumbers"];
      memberId?: string;
      internalAccountId: string;
      currency: components["schemas"]["Currency"];
      userId: string;
    };
    InternalAccountStatement: {
      accountStatementId: string;
      userId: string;
      internalAccountId: string;
      internalAccountType: components["schemas"]["InternalAccountType"];
      currency: components["schemas"]["Currency"];
      startDateString: string;
      endDateString: string;
      openingBalance: number;
      endingBalance: number;
      totalWithdrawals: number;
      totalDeposits: number;
      createdAt: string;
      entries?: components["schemas"]["InternalAccountStatementEntry"][];
      fileId?: string;
    };
    InternalAccountStatementEntry: {
      entryId: string;
      localDateString: string;
      description: string;
      extendedDescription?: string;
      amount: number;
      /** @enum {string} */
      direction: "Credit" | "Debit";
      balance: number;
      transactionId?: string;
    };
    /** @enum {string} */
    InternalAccountStatus: "Active" | "Inactive" | "Closed" | "Pending";
    /** @enum {string} */
    InternalAccountType:
      | "Clearing"
      | "CardClearing"
      | "TaxWithholding"
      | "Banking"
      | "InternationalClearing"
      | "ApPrefunding"
      | "ApPayouts";
    InternalAccountNumbers: {
      account?: string;
      routing?: string;
    };
    /** @enum {string} */
    Currency: "USD" | "EUR" | "GBP" | "CAD" | "AUD" | "CZK";
    InternalAccountCreate: {
      /** @enum {string} */
      type:
        | "Clearing"
        | "CardClearing"
        | "TaxWithholding"
        | "Banking"
        | "InternationalClearing"
        | "ApPrefunding"
        | "ApPayouts";
      currency: components["schemas"]["Currency"];
    };
    AccountBalance: {
      /** @description The current balance of the account */
      balance: number;
      /** @description The available balance of the account (may differ from current balance due to pending transactions) */
      available?: number;
      /** @description The amount currently on hold or reserved in the account */
      hold?: number;
      /** @description The sum of pending transactions that have not settled yet */
      pending?: number;
      currency: components["schemas"]["Currency"];
      /** @description The ID of the internal account */
      internalAccountId: string;
      internalAccountType: components["schemas"]["InternalAccountType"];
      /**
       * Format: date-time
       * @description The timestamp when the balance was last updated
       */
      updatedAt?: Date;
    };
    Transaction: {
      amount: number;
      business: boolean;
      createdAt: Date;
      /** @enum {string} */
      currency: "USD" | "CAD";
      /**
       * Format: date-time
       * @description Transaction date
       */
      date: Date;
      eventActors: {
        [key: string]: string;
      };
      labels: {
        [key: string]: string;
      };
      /** @enum {string} */
      latestUpdateSource: "Plaid" | "System" | "User";
      memberId: string;
      name: string;
      /** @enum {string} */
      status: "Active" | "Inactive" | "Pending";
      transactionId: string;
      /** @enum {string} */
      type:
        | "Expense"
        | "Income"
        | "Transfer"
        | "Fee"
        | "ATMTransaction"
        | "Refund"
        | "Reward"
        | "Unknown";
      updatedAt: Date;
      userRoles?: {
        ownerIds: string[];
        viewerIds: string[];
      };
      accountId?: string;
      authorizedDate?: string;
      businessAmount?: number;
      businessBanking?: boolean;
      category?: string[];
      deductibleAmount?: number;
      editedByUser?: boolean;
      externalIds?: {
        plaidAccountId?: string;
        plaidItemId?: string;
        plaidTransactionId?: string;
        trackExpenseId?: string;
      };
      internal?: {
        unitCardId?: string;
        unitInterchange?: number;
        unitTransactionId?: string;
      };
      invoiceId?: string;
      location?: string;
      merchantCategory?: string;
      merchantName?: string;
      note?: string;
      /** @enum {string} */
      paymentChannel?: "Online" | "InStore" | "Other";
      receiptFileId?: string;
      scheduleCDescription?: string;
      scheduleCLineNumber?: string;
      wingspanCardId?: string;
      /** @enum {string} */
      wsCategory?:
        | "Advertising & Marketing"
        | "ATM Transaction"
        | "Bank Fee"
        | "Business Insurance"
        | "Business License"
        | "Car Expense"
        | "Commission"
        | "Contractor Payment"
        | "Education"
        | "Entertainment"
        | "Gift"
        | "Home Expense"
        | "Income"
        | "Interest"
        | "Legal & Professional Service"
        | "Meal"
        | "Office Rent"
        | "Other Business Expense"
        | "Other Deductions"
        | "Payroll"
        | "Phone Bill"
        | "Refund"
        | "Software"
        | "Supplies"
        | "Taxes"
        | "TollFee"
        | "Transfer"
        | "Travel & Transport"
        | "Vehicles, Machinery & Equipment"
        | "Veterinary Services";
    };
    TransactionList: {
      /** @description List of transactions */
      transactions: components["schemas"]["Transaction"][];
      /** @description Total number of transactions matching the filter criteria */
      total: number;
    };
    TransferCreate: {
      /** @description The ID of the internal account to create the transfer on */
      internalAccountId: string;
      /** @description The amount to transfer */
      amount: number;
      /**
       * @description The direction of the transfer relative to the account
       * @enum {string}
       */
      direction: "Deposit" | "Withdrawal";
      /** @description Description of the transfer purpose */
      description: string;
      /**
       * @description The transfer method to use for the transfer
       * @default ACH
       * @enum {string}
       */
      transferMethod?: "ACH" | "Wire" | "RealTime" | "Internal";
      /** @description The ID of the counterparty account (source for deposits, destination for withdrawals) */
      counterpartyAccountId?: string;
      /**
       * @description The type of the counterparty account
       * @enum {string}
       */
      counterpartyAccountType?: "InternalAccount" | "Account" | "PaymentCard";
      /**
       * Format: date
       * @description Optional date to schedule the transfer for future processing
       */
      scheduledDate?: string;
      /** @description Additional reference information for the transfer */
      metadata?: {
        /** @description Unique identification assigned by the initiating party to unambiguously identify the transaction */
        endToEndIdentification?: string;
        /** @description ISO 20022 purpose code for the transfer (e.g., SALA for salary, SUPP for supplier payment) */
        purposeCode?: string;
        /** @description Information from the originator to the beneficiary */
        originatorToBeneficiaryInformation?: string;
        /** @description Reference information for the beneficiary's reconciliation */
        referenceForBeneficiary?: string;
        [key: string]: string | undefined;
      };
    };
    Transfer: {
      /** @description Unique identifier for the transfer */
      transferId: string;
      /** @description The internal account ID associated with this transfer */
      internalAccountId: string;
      /** @description The transfer amount */
      amount: number;
      currency: components["schemas"]["Currency"];
      /**
       * @description The direction of the transfer
       * @enum {string}
       */
      direction: "Deposit" | "Withdrawal";
      /** @description Description of the transfer */
      description: string;
      /**
       * @description Current status of the transfer
       * @enum {string}
       */
      status:
        | "Created"
        | "InProgress"
        | "Completed"
        | "Failed"
        | "Cancelled"
        | "Returned";
      /**
       * @description Reason for failure if status is Failed
       * @enum {string}
       */
      statusReason?:
        | "InternalError"
        | "ExternalFailure"
        | "BadPayoutMethod"
        | "InsufficientFunds";
      /**
       * @description The transfer method used
       * @enum {string}
       */
      transferMethod: "ACH" | "Wire" | "RealTime" | "Internal";
      /**
       * Format: date
       * @description Scheduled date for the transfer if applicable
       */
      scheduledDate?: string;
      /**
       * Format: date-time
       * @description Timestamp when the transfer was processed
       */
      processedAt?: Date;
      /**
       * Format: date-time
       * @description Timestamp when the transfer was completed
       */
      completedAt?: Date;
      /** @description Reference information and tracking details for the transfer */
      metadata?: {
        /** @description Unique identification assigned by the initiating party */
        endToEndIdentification?: string;
        /** @description ISO 20022 purpose code for the transfer */
        purposeCode?: string;
        /** @description Information from the originator to the beneficiary */
        originatorToBeneficiaryInformation?: string;
        /** @description Reference information for beneficiary reconciliation */
        referenceForBeneficiary?: string;
        [key: string]: string | undefined;
      };
      /**
       * Format: date-time
       * @description Timestamp when the transfer was created
       */
      createdAt: Date;
      /**
       * Format: date-time
       * @description Timestamp when the transfer was last updated
       */
      updatedAt: Date;
      /** @description External system identifiers for tracking */
      externalIds?: {
        [key: string]: string;
      };
    };
    Error: {
      error?: string;
      errorDetail?: string[];
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}

export type $defs = Record<string, never>;

export type external = Record<string, never>;

export interface operations {
  /**
   * List Internal Account Statements
   * @description Lists all available statements for platform financial accounts, with optional filtering by specific internal account ID
   */
  listInternalAccountStatements: {
    parameters: {
      query?: {
        /** @description The ID of the internal account to retrieve statements for */
        internalAccountId?: string;
      };
    };
    responses: {
      /** @description List of statements */
      200: {
        content: {
          "application/json": components["schemas"]["InternalAccountStatement"][];
        };
      };
      /** @description Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * Retrieve Internal Account Statement
   * @description Retrieves a single account statement by its ID, including all transaction entries within the statement period
   */
  retrieveInternalAccountStatement: {
    parameters: {
      path: {
        /** @description The ID of the statement to retrieve */
        internalAccountStatementId: string;
      };
    };
    responses: {
      /** @description Banking account statement */
      200: {
        content: {
          "application/json": components["schemas"]["InternalAccountStatement"];
        };
      };
      /** @description Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * List Internal Accounts
   * @description Returns a list of internal accounts with optional filtering by account type.
   */
  listInternalAccounts: {
    parameters: {
      query?: {
        /** @description The type of bank accounts to retrieve */
        type?:
          | "Clearing"
          | "TaxWithholding"
          | "Banking"
          | "InternationalClearing"
          | "ApPrefunding"
          | "ApPayouts";
      };
    };
    responses: {
      /** @description Successful response */
      200: {
        content: {
          "application/json": components["schemas"]["InternalAccount"][];
        };
      };
      /** @description Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * Create Internal Account
   * @description Creates a new internal account for the customer.
   * - Clearing, Banking, TaxWithholding accounts only support USD currency
   * - ApPrefunding accounts support USD, CAD, and EUR currencies
   * - ApPayouts accounts support USD, CAD, and EUR currencies
   * - InternationalClearing accounts support USD and CAD currencies
   */
  createInternalAccount: {
    requestBody: {
      content: {
        "application/json": components["schemas"]["InternalAccountCreate"];
      };
    };
    responses: {
      /** @description Bank account created successfully */
      200: {
        content: {
          "application/json": components["schemas"]["InternalAccount"];
        };
      };
      /** @description Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * Retrieve Internal Account
   * @description Retrieves details of a specific internal account by its ID.
   */
  getInternalAccount: {
    parameters: {
      path: {
        /** @description The ID of the bank account to retrieve */
        internalAccountId: string;
      };
    };
    responses: {
      /** @description Successful response */
      200: {
        content: {
          "application/json": components["schemas"]["InternalAccount"];
        };
      };
      /** @description Bank account not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * Retrieve Internal Account Balance
   * @description Retrieves the current monetary balance, along with the respective currency, for any supported internal account type.
   * Supported account types include Business Banking, Withholdings, Clearing, AP Prefunding, AP Payout, and International Clearing.
   */
  getInternalAccountBalance: {
    parameters: {
      path: {
        /** @description The ID of the internal account to retrieve the balance for */
        internalAccountId: string;
      };
    };
    responses: {
      /** @description Current balance of the internal account */
      200: {
        content: {
          "application/json": components["schemas"]["AccountBalance"];
        };
      };
      /** @description Invalid request or unsupported account type */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** @description Not authorized to access this account */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** @description Internal account not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * Create Internal Account Transfer
   * @description Initiates a new transfer (deposit or withdrawal) for an internal account.
   * The transfer is created in a pending state and will be processed according to the specified payment method and timing.
   * Supports ACH, wire transfers, and internal transfers between Wingspan accounts.
   */
  createInternalAccountTransfer: {
    parameters: {
      path: {
        /** @description The ID of the internal account to transfer from/to */
        internalAccountId: string;
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["TransferCreate"];
      };
    };
    responses: {
      /** @description Transfer initiated successfully */
      200: {
        content: {
          "application/json": components["schemas"]["Transfer"];
        };
      };
      /** @description Invalid request parameters or insufficient balance */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** @description Internal account not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /**
   * List transactions for a specific internal account
   * @description Retrieves a list of transactions for a specific internal account, with support for filtering, sorting, and pagination.
   * Supported account types include Business Banking, Withholdings, Clearing, AP Prefunding, AP Payout, and International Clearing.
   */
  listInternalAccountTransactions: {
    parameters: {
      query?: {
        /** @description Filter transactions by effective date (greater than or equal to) */
        "filter[effectiveAt][>=]"?: string;
        /** @description Filter transactions by effective date (less than or equal to) */
        "filter[effectiveAt][<=]"?: string;
        /** @description Filter transactions by status */
        "filter[status]"?: "Active" | "Pending" | "Inactive";
        /** @description Search for transactions by description (substring match) */
        "filter[description]"?: string;
        /** @description Cursor string for pagination after a specific transaction */
        "filter[after]"?: string;
        /** @description Maximum number of transactions to return per page */
        "page[size]"?: number;
        /** @description Field to sort transactions by, prefix with - for descending order */
        sort?: "effectiveAt" | "-effectiveAt";
      };
      path: {
        /** @description The ID of the internal account to retrieve transactions for */
        internalAccountId: string;
      };
    };
    responses: {
      /** @description List of transactions for the internal account */
      200: {
        content: {
          "application/json": components["schemas"]["TransactionList"];
        };
      };
      /** @description Invalid request parameters */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** @description Not authorized to access this account */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** @description Internal account not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
}

export type InternalAccountStatement =
  components["schemas"]["InternalAccountStatement"];
export type InternalAccountStatementEntry =
  components["schemas"]["InternalAccountStatementEntry"];

export enum InternalAccountStatus {
  Active = "Active",
  Inactive = "Inactive",
  Closed = "Closed",
  Pending = "Pending"
}

export enum InternalAccountType {
  Clearing = "Clearing",
  CardClearing = "CardClearing",
  TaxWithholding = "TaxWithholding",
  Banking = "Banking",
  InternationalClearing = "InternationalClearing",
  Deductions = "Deductions",
  Rewards = "Rewards",
  InternalOperations = "InternalOperations",
  ApFunding = "ApFunding",
  ApPayouts = "ApPayouts"
}

export type IInternalAccount = {
  status: InternalAccountStatus;
  customerUserId?: string;
  customerName?: string;
  name: string;
  type: InternalAccountType;
  numbers?: components["schemas"]["InternalAccountNumbers"];
  memberId?: string;
  internalAccountId: string;
  currency: components["schemas"]["Currency"];
};
